import {
  createReducer,
  createFetchReducers,
  createFetchReducersWithPagination,
  createFetchSelectors,
  createFetchPaginatedActionForNamespace,
  createPostActionForNamespace,
  createFetchActionForNamespace
} from 'utils/reducers';
import {selectPagination, PAGINATION} from 'ducks/pagination';
import {transformPaginationForStoreToPaginationForApi} from 'utils/pagination';

const createFetchActionWithPagination = createFetchPaginatedActionForNamespace(
  'oneOffChargeReasons'
);
const createFetchAction = createFetchActionForNamespace('oneOffChargeReasons');

const createPostAction = createPostActionForNamespace('oneOffChargeReasons');

export const fetchOneOffChargeReasons = createFetchActionWithPagination({
  name: 'FETCH_ONE_OFF_CHARGE_REASONS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {locationRef, extraActions}
  }),
  stateKey: 'list',
  defaultStateValue: [],
  extraGetParamsSelectors: [
    state =>
      transformPaginationForStoreToPaginationForApi(
        selectPagination(state, PAGINATION.ONE_OFF_CHARGE_REASONS_LIST)
      )
  ],
  paginationNamespace: PAGINATION.ONE_OFF_CHARGE_REASONS_LIST
});

const oneOffChargeReasonsSelector = createFetchSelectors(
  fetchOneOffChargeReasons
);
export const selectOneOffChargeReasons = oneOffChargeReasonsSelector.data;
export const selectOneOffChargeReasonsLoading =
  oneOffChargeReasonsSelector.isLoading;

export const createOneOffChargeReason = createPostAction({
  name: 'CREATE_ONE_OFF_CHARGE_REASON',
  initialAction: (
    {label, description, amount, location, account},
    extraActions = []
  ) => ({
    payload: {label, description, amount, location, account, extraActions}
  }),
  formName: 'createOneOffChargeReason'
});

export const editOneOffChargeReason = createPostAction({
  name: 'EDIT_ONE_OFF_CHARGE_REASON',
  initialAction: (
    {reasonId, label, description, amount, locationRef, account},
    extraActions = []
  ) => ({
    payload: {
      reasonId,
      label,
      description,
      amount,
      locationRef,
      account,
      extraActions
    }
  }),
  formName: 'editOneOffChargeReason'
});

export const deleteOneOffChargeReason = createPostAction({
  name: 'DELETE_ONE_OFF_CHARGE_REASON',
  initialAction: ({reasonId, locationRef}, extraActions = []) => ({
    payload: {reasonId, locationRef, extraActions}
  })
});

export const fetchPaymentMethods = createFetchAction({
  name: 'FETCH_PAYMENT_METHODS',
  initialAction: ({locationRef}, extraActions = []) => ({
    payload: {
      locationRef,
      extraActions
    }
  }),
  stateKey: 'paymentMethods',
  defaultStateValue: []
});
export const selectPaymentMethods = createFetchSelectors(fetchPaymentMethods)
  .data;

export const MODALS = {
  CREATE_ONE_OFF_CHARGE_REASON: 'createOneOffChargeReason',
  EDIT_ONE_OFF_CHARGE_REASON: 'editOneOffChargeReason'
};

const initialState = {};

const fetchReducers = createReducer(initialState, {
  ...createFetchReducersWithPagination(fetchOneOffChargeReasons),
  ...createFetchReducers(fetchPaymentMethods)
});

const reducer = (state = {}, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as oneOffChargeReasonsSaga} from './saga';
